export enum FeatureFlag {
  EnableZipPlus = 'use_classification_4',
  ZipPlusAcquiPhaseTwo = 'classification_4_acqui_phase_two',
  ZipPlusInviteCustomer = 'classification_4_new_customers',
  EnableExpiresSoon = 'enable_expires_soon',
  EnablePlanToPurchase = 'enable_plan_to_purchase',
  EnableSelectiveMFA = 'enable_selective_mfa',
}
